import React, { useState, useEffect } from 'react';
import BlogPostsBulkDeleteModal from './BlogPostsBulkDeleteModal';

const BlogPostsBulkActions = ({ 
  selectedPosts, 
  clearSelectedPosts, 
  onBulkDelete 
}) => {
  const [bulkAction, setBulkAction] = useState('');
  const [isBulkDeleteModalOpen, setIsBulkDeleteModalOpen] = useState(false);

  useEffect(() => {
    if (selectedPosts.length === 0) {
      setBulkAction('');
    }
  }, [selectedPosts]);

  const handleBulkAction = async () => {
    if (!selectedPosts.length) {
      alert('No posts selected.');
      return;
    }

    if (bulkAction === 'delete') {
      setIsBulkDeleteModalOpen(true);
    }
  };

  return (
    <div className="bulk-actions-container">
      <select
        className="bulk-actions-select"
        value={bulkAction}
        onChange={(e) => setBulkAction(e.target.value)}
        style={{
          backgroundColor: selectedPosts.length > 0 ? '#f8f8f8' : '#f2f2f2',
          color: selectedPosts.length > 0 ? '#000' : '#999',
        }}
      >
        <option value="">Bulk Actions</option>
        <option value="delete">Delete</option>
      </select>
      <button
        className="button secondary"
        onClick={handleBulkAction}
        disabled={!bulkAction || selectedPosts.length === 0}
      >
        Apply
      </button>

      <BlogPostsBulkDeleteModal
        isOpen={isBulkDeleteModalOpen}
        onClose={() => {
          setIsBulkDeleteModalOpen(false);
          clearSelectedPosts();
        }}
        onSuccess={() => {
          if (onBulkDelete) {
            onBulkDelete();
          }
          setIsBulkDeleteModalOpen(false);
          clearSelectedPosts();
          setBulkAction('');
        }}
        selectedPosts={selectedPosts}
      />
    </div>
  );
};

export default BlogPostsBulkActions; 